// The versioned URL for a legacy prototype file (public/js, public/css). The versions are
// content fingerprints computed at build time (legacy-versions.plugin.ts) — so a changed
// file gets a new URL and every browser re-downloads it, despite the site's year-long
// immutable caching; an unchanged file keeps its URL and stays cached.

declare const __LEGACY_ASSET_VERSIONS__: Record<string, string>;

/** e.g. versionedUrl("js/main.js") → "/js/main.js?v=3f2a9c1b04". Throws when the build
 *  has no version for the file (e.g. a deploy missing the snapshot) — failing loudly
 *  beats silently serving a stale cached copy. */
export function versionedUrl(path: string, versions: Record<string, string> = __LEGACY_ASSET_VERSIONS__): string {
  const v = versions[path];
  if (!v) throw new Error(`No build version for legacy file ${path} — was it present at build time?`);
  return `/${path}?v=${v}`;
}
